import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "sd-calendar-outline",
  "use": "sd-calendar-outline-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"sd-calendar-outline\"><path d=\"M5 2a1 1 0 011-1h2a1 1 0 011 1v2H5V2zm10 0a1 1 0 011-1h2a1 1 0 011 1v2h-4V2zM0 6a2 2 0 012-2h7v4H2v14h20V8h-7V4h7a2 2 0 012 2v17a1 1 0 01-1 1H1a1 1 0 01-1-1V6z\" /><path d=\"M15 4v4H9V4h6z\" /><path d=\"M9 11H5v4h4v-4zm5 0h-4v4h4v-4zm1 0h4v4h-4v-4zm-6 5H5v4h4v-4zm1 0h4v4h-4v-4zm9 0h-4v4h4v-4z\" opacity=\".5\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol